<template>
  <div>
    <div v-if = 'view_name == "Home"'></div>
    <nav v-else class="navbar-aureal">
      <div class="navbar-mobile">
        <div class="w-100 pb-1">
          <span>
            <div  class = 'pointer' @click="back()">
            <img class ='icons-arrow'
                :src="require('@/assets/icons/icon-arrow-back.svg')"
                alt="user icon"
            />
            <span v-bind:class="{ 'text-color-cargador': view_role=='Cargador','text-color-transitario': view_role=='Transitario' }">{{view_role}}</span>
            </div>
          </span>
        </div>
        <div class="w-100 pl-5 ml-2">
          <h4>{{view_name}}</h4>
        </div>
      </div>
      <div class="navbar-screen">
        <div class="navbar-screen-left">
            <img
              :src="require('@/assets/logo.png')"
              alt="aureal logo"
            />
        </div>
      </div>
      <div v-if="isLoggedIn" class="user-info">
        <a class="d-block pointer logout" @click="logout()"><span>Cerrar sesión</span></a>
        
        <router-link to="/notifications">
          <img class ='icons-alert' :src="require('@/assets/icons/alert.svg')" alt="alert icon"  />
        </router-link>
        <!-- <span class="d-block">Usuario</span> -->
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "aurealHeader",
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(["view_name","view_role"]),  
    ...mapGetters("user",{
      isLoggedIn: 'isLoggedIn',
      name: 'name'
    }),
    ...mapGetters("container",{
      container_id: 'container_id',
      action_list: 'action_list'
    }),  
  },
  mounted () { 
  },
  methods: {
    logout: function () {
        this.$store.dispatch('user/logout')
       .then(resp => { this.$router.push("/login")})
       .catch(err => err)
    },
    back: function () {
      var router = this.$router
      switch (this.$router.currentRoute.name) {
        case 'ContainerView':
            router.push('Containers')
            return
        case 'Containers':
            router.push('MainMenu')
            return
        case 'MainMenu':
            router.push('SelectRole')
            return
        default:
            window.history.back()
            return
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang= "scss" scoped>

$border-color: #32AC91;

.navbar-aureal {
    position: relative;
    background-color: $nav-background-mobile;
    color: $text-nav-mobile;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: .2rem 1rem .5rem 0rem;
    box-shadow: 0px 3px 6px $nav-shadow;
    border-left: 5px solid $border-color;
}
.navbar-screen{
  display: none;
}
.navbar-mobile {
  display: block;
}
.user-info{
  position: absolute;
  top: 0px;
  right: 16px;
  /* margin-top: 20px; */
}
.logout {
  padding-bottom: 5px;
}

 @media only screen and (min-width: $mobile-width) {
    .navbar-aureal {
      box-shadow: none;
      background-color: $nav-background-screen;
      border-left: 5px solid $nav-background-screen;
      color: $text-nav-screen;
    }
    .navbar-screen{
      display: block;
      margin-top: 11px;
      margin-bottom: 12px;
    }
    .navbar-mobile {
      display: none;
    }
    .navbar-screen-left > img {
        height: 100%;
        max-width: 175px;
    }
  }

</style>
